<template>
  <div class="section-hr" :class="{ 'no-hr-padding': noHrPadding }">
    <hr color="#DCDDDE" />
  </div>
</template>
<script>
export default {
  name: "HR",
  props: {
    noHrPadding: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">
.section-hr {
  display: flex;
  justify-content: center;
  margin-top: 88px;
  hr {
    width: 1280px;
    max-width: 60vw;
  }
}
.no-hr-padding {
    margin-top: 0;
  }
</style>
